import {
  MDBCol,
  MDBRow,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { getAgents } from "../../apiclients/streamsapi_bridge";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import MGroups from "../../components/topviews/MGroups";
// import SMSGroups from "../../components/topviews/SMSGroups";
import UGroups from "../../components/topviews/UserGroups";
import ULocations from "../../components/topviews/UserLocations";
import Users from "../../components/topviews/Users";
import EditWarning from "../../components/header/EditWarning";
import { isFiveNineAccount } from "../Login";
import TabIDConstant from "../../apiclients/TabIDConstant";
function UserLandingPage(props) {

  // const [basicActive1, setBasicActive1] = useState("suser");

  const [basicActive, setBasicActive] = useState("muser");

  const showMain = (value) => {
    if (value === basicActive1) {
      return;
    }
    setBasicActive1(value);
  };
  const showSub = (value) => {
    if (value === basicActive2) {
      return;
    }

    setBasicActive2(value);
  };
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };
  const [basicModal, setBasicModal] = useState(false);

  const basicData4 = {
    columns: ["Paging Group", "Group ID", "Remove"],
    rows: [
      ["Poly VVX 601", "1", "X"],
      ["Poly VVX 601", "2", "X"],
      ["Poly VVX 601", "3", "X"],
      ["Poly VVX 601", "4", "X"],
    ],
  };
  const basicData5 = {};
  const toggleShow = () => setBasicModal(!basicModal);

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const usergroup = {
    columns: ["Name", "Users", "Remove"],
    columnWidths: ["10%", "40%", "30%"],
    rows: [
      [
        "Tiger Nixon",
        "System Architect",
        <i className="fas fa-xmark text-primary"></i>,
      ],
    ],
  };
  const location = useLocation();
  const [addUsers, setAddUsers] = useState(
    location.state ? location.state.openadd : false
  );
  const actTab = location.state ? location.state.tab ? location.state.tab : "suser" : "suser";
  const actTab2 = location.state ? location.state.tab2 ? location.state.tab2 : "suser" : "suser";
  const [basicActive1, setBasicActive1] = useState(actTab);
  const [basicActive2, setBasicActive2] = useState(actTab2);
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);

  const [userList, setuserList] = useState([]);
  const [isFiveNineAcc , setisFiveNineAcc] = useState(false);

  function openAddUserPopup(e) {
    setAddUsers(!addUsers);
  }

  const navigate = useNavigate();

  function showThisInf(data) {
    navigate("/userDetails", {
      state: { id: 0 },
    });
  }

  const [Adduser, setAdduser] = useState(false);
  const toggleShow20 = () => setAdduser(!Adduser);

  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    sessionStorage.setItem("current_link", "userlanding");
    const response = await getAgents(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      TabIDConstant.USERS_SUBLINK
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const rawData = await response.json();
    if (!rawData) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("user data :::::::: " + JSON.stringify(rawData));
    setuserList(rawData.users);
  }

  /********************************Fetching Display Data Starts Here!************************************************* */
  useEffect(() => {
    setisFiveNineAcc(isFiveNineAccount())
    fetchData();
  }, []);
  /********************************************************************************* */



  return (
    <React.Fragment>
      <>
        <MainLinks active={3} />
        <Body
          tablinks={3}
          sublink={8}
          content={
            <>
              <section className="mb-3 useres-tab">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">{t("users")}</h5>
                  </div>
                  <div className="card-body usersTab_btns px-0">
                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "muser"}>
                        <MDBTabs>
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => showMain("suser")}
                              active={basicActive1 === "suser"}
                            >
                              {t("users")}
                            </MDBTabsLink>
                          </MDBTabsItem>
                          <MDBTabsItem>
                            {!isFiveNineAcc && (
                              <MDBTabsLink
                                onClick={() => showMain("mgroups")}
                                active={basicActive1 === "mgroups"}
                              >
                                {t("usergroups")}
                              </MDBTabsLink>
                            )}
                          </MDBTabsItem>
                        </MDBTabs>
                        <MDBTabsContent>
                          <MDBTabsPane
                            open={basicActive1 === "suser"}
                            className="pt-0"
                          >
                            <div className="tab-margin-3">
                              <MDBTabs>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => showSub("suser")}
                                    active={basicActive2 === "suser"}
                                  >
                                    {t("users")}

                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => showSub("sloc")}
                                    active={basicActive2 === "sloc"}
                                  >
                                    {t("locations")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  {!isFiveNineAcc && (
                                    <MDBTabsLink
                                      onClick={() => showSub("sgroups")}
                                      active={basicActive2 === "sgroups"}
                                    >
                                      {t("All Groups")}
                                    </MDBTabsLink>
                                  )}
                                </MDBTabsItem>
                                {/* <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => showSub("smsGroups")}
                                    active={basicActive2 === "smsGroups"}
                                  >
                                    {t("smsgroups")}
                                  </MDBTabsLink>
                                </MDBTabsItem> */}
                              </MDBTabs>
                            </div>

                            <MDBTabsContent className="mt-3">
                              <MDBTabsPane
                                open={basicActive2 === "suser"}
                                className="borderactive"
                              >
                                <Users addUsers={addUsers} userList={userList} isActive={basicActive2 === "suser" && basicActive1==="suser"} />
                              </MDBTabsPane>
                              <MDBTabsPane
                                open={basicActive2 === "sloc"}
                                className="borderactive"
                              >
                                <ULocations isActive={basicActive2 === "sloc"}  />
                              </MDBTabsPane>
                              <MDBTabsPane
                                open={basicActive2 === "sgroups"}
                                className="borderactive"
                              >

                                <UGroups isActive={basicActive2 === "sgroups"}   />
                              </MDBTabsPane>
                              {/* <MDBTabsPane
                                open={basicActive2 === "smsGroups"}
                                className="borderactive"
                              >
                                <SMSGroups />
                              </MDBTabsPane> */}


                            </MDBTabsContent>
                          </MDBTabsPane>
                          <MDBTabsPane open={basicActive1 === "mgroups"} >
                            <MDBRow className="tab__border">
                              <MDBCol size="12" className="px-0">
                                <div className="pt-0 mt-2">
                                  <MGroups isActive={basicActive1 === "mgroups"}  />
                                </div>
                              </MDBCol>
                            </MDBRow>
                          </MDBTabsPane>
                        </MDBTabsContent>
                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>
                </div>
              </section>
            </>
          }
        />
        {showWarning && (
        <EditWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
        />
      )}
        {/* <Footer /> */}
      </>
    </React.Fragment>
  );
}

export default UserLandingPage;
